import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { generateCacheKey, withManualCache } from '@/utlility/cache-service';

const API_URL = process.env.NEXT_PUBLIC_API_URL;

// Fetch organization features data
export const fetchNavigationData = createAsyncThunk(
  'organization/fetchNavigationData',
  async ({ organizationId }, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/organization-data`;
      const payload = { organization_key: organizationId };
      const cacheKey = generateCacheKey(url, 'POST', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.post(url, payload);
        return response.data?.data || {};
      });
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Fetch organization settings/header data
export const fetchHeaderData = createAsyncThunk(
  'organization/fetchHeaderData',
  async ({ organization_key }, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/setting-data`;
      const payload = { organization_key };
      const cacheKey = generateCacheKey(url, 'POST', payload);
      return await withManualCache(cacheKey, async () => {
        const response = await axios.post(url, payload);
        return response.data?.data || {};
      });
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const organizationSlice = createSlice({
  name: 'organization',
  initialState: {
    featuresData: null,
    headerData: null,
    loading: false,
    error: null,
  },
  reducers: {
    setOrganizationData: (state, action) => {
      if (action.payload.featuresData) state.featuresData = action.payload.featuresData;
      if (action.payload.headerData) state.headerData = action.payload.headerData;
    }
  },
  extraReducers: (builder) => {
    builder
      // Features
      .addCase(fetchNavigationData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNavigationData.fulfilled, (state, action) => {
        state.loading = false;
        state.featuresData = action.payload;
      })
      .addCase(fetchNavigationData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Header/Settings
      .addCase(fetchHeaderData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHeaderData.fulfilled, (state, action) => {
        state.loading = false;
        state.headerData = action.payload;
      })
      .addCase(fetchHeaderData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setOrganizationData } = organizationSlice.actions;
export default organizationSlice.reducer;
